'use client';

import { Login } from 'domains/Auth';

const LoginPage: React.FC = () => {
  return <Login />;
};

export default LoginPage;
